import { services, supplyImage } from '@/mocks/home';
import SectionHead from './SectionHead';

export default function Supply() {
  return (
    <section id="supply" className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-12 py-24 md:py-32">
        <SectionHead label="Supply & Sourcing" title="MORE THAN COMPONENTS." intro="NORTHLINE is a supplier and distributor. We connect your project requirements with suitable components and keep procurement clear from enquiry to delivery." />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mt-14 md:mt-20">
          <div data-mo="image" className="lg:col-span-6 r-img relative w-full h-[420px] md:h-[600px] lg:h-auto lg:self-stretch">
            <img src={supplyImage} alt="Industrial valves and fittings prepared for supply" title="Component sourcing - NORTHLINE" className="absolute inset-0 w-full h-full object-cover object-top" />
          </div>
          <div data-mo="group" className="lg:col-span-6 flex flex-col justify-center">
            {services.map((s) => (
              <div key={s.no} className="grid grid-cols-[48px_1fr] md:grid-cols-[64px_1fr] gap-4 py-8 md:py-10 border-t border-background-300 last:border-b">
                <span className="t-body text-primary-500 tabular-nums">{s.no}</span>
                <div>
                  <h3 className="t-feature text-foreground-950">{s.title}</h3>
                  <p className="mt-3 t-body text-foreground-600">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}